import { AvailableSalesProducts, EXCLUDED_PRODUCTS_FOR_SALES, Product, PRODUCTS, REGIONS } from '@boltenergy-be/shared'
import { AvailableProducts } from 'types/parameters'

/**
 * Type guard to check if available products by region has the correct format
 * @param availableProducts
 * @returns {availableProducts is AvailableProducts}
 */
export const isValidAvailableProducts = (availableProducts?: unknown): availableProducts is AvailableProducts => {
  return (
    !!availableProducts &&
    typeof availableProducts === 'object' &&
    !Array.isArray(availableProducts) &&
    REGIONS.brussels in availableProducts &&
    REGIONS.wallonia in availableProducts &&
    REGIONS.flanders in availableProducts
  )
}

/**
 * Type guard to check if a product is an available sales product
 * @param {string} product
 * @returns {product is AvailableSalesProducts}
 */
export const isAvailableSalesProduct = (product: string): product is AvailableSalesProducts => {
  return Object.values(PRODUCTS).includes(product as Product) && !(EXCLUDED_PRODUCTS_FOR_SALES as string[]).includes(product)
}
